<template>
    <div class="row m-0 formdynamic" :class="content_align_x ? content_align_x : 'justify-content-md-between'" style="padding-top:10px;">
        <!-- <div v-for="(key, index) in form_format" :key="index" :class="key.css_class" class="p-0 formdynamic__item" style="right:0px;"> -->
        <slot :name="`start-fields`"></slot>  
        <div v-for="(key, index) in form_format" :key="index" :class="`${key.css_class} ${content_align_x ? '' : 'p-0'}`" class="formdynamic__item py-0" style="margin-top:20px" :style="key.style">
            <div class="formdynamic__item__field" :id="key.id">
                
                <label v-html="`${key.name} ${key.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label" :class="key.label_class" :for="key.name"/>

                <textarea v-if="key.type === 'textarea'"
                    :disabled="key.disabled"
                    class="" 
                    style=""
                    :maxlength="key.maxlength"
                    :required="key.required"
                    v-model="form_data[key.model_name]"
                    :ref="for_update ? key.ref_alt : key.ref"
                    rows="5"
                />

                <select v-else-if="key.type === 'select' || key.type === 'select-multiple'"
                    :disabled="key.disabled"
                    :multiple="key.type === 'select-multiple' ? true : false"
                    :size="key.maxlength"
                    class="input-field custom-select"
                    :required="key.required"
                    v-model="form_data[key.model_name]"
                    :ref="for_update ? key.ref_alt : key.ref"
                >
                    <!-- <option value='' :disabled="[[key.required ? true : false], [key.type === 'select-multiple' ? true : false]]" v-html="key.name"/> -->
                    <option value='' :disabled="key.required" v-html="key.empty_option_name !== undefined && key.empty_option_name !== '' ? key.empty_option_name : 'Select an option'"/>
                    <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.id" v-html="key.label ? value[key.label] : value.name"/>
                </select>

                <span class="custom-control custom-checkbox" v-else-if="key.type === 'checkbox'">
                    <input 
                        :disabled="key.disabled"
                        :type="key.type" 
                        :value="key.value ? key.value : null"
                        class="custom-control-input"
                        :id="for_update ? `refAlt${index}${alt}${name}` : `ref${index}${alt}${name}`"
                        v-model="form_data[key.model_name]"
                    />
                    <!-- <label
                        class="custom-control-label ml-2"
                        :for="for_update ? `refAlt${index}${alt}` : `ref${index}${alt}`"
                        v-html="form_data[key.model_name] ? 'Yes' : 'No'"
                    /> -->
                    <label
                        class="custom-control-label ml-2"
                        :for="for_update ? `refAlt${index}${alt}${name}` : `ref${index}${alt}${name}`"
                    />
                </span>

                <span class="row m-0" v-else-if="key.type === 'checkbox-plus'">
                    <div v-for="(val, j) in key.childs" :key="j" :class="val.css_class" class="px-0">
                        <label v-html="`${val.name} ${val.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label "/>
                        <div class="custom-control custom-checkbox">
                            <input 
                                :disabled="val.disabled"
                                :type="val.type" 
                                class="custom-control-input"
                                :id="for_update ? `refAlt${index}${j}${alt}` : `ref${index}${j}${alt}`"
                                v-model="form_data[val.model_name]"
                            />
                            <label
                                class="custom-control-label ml-2"
                                :for="for_update ? `refAlt${index}${j}${alt}` : `ref${index}${j}${alt}`"
                            />
                        </div>
                    </div>
                </span>

                <span class="row m-0" v-else-if="key.type === 'number-plus'">
                    <div v-for="(val, j) in key.childs" :key="j" :class="val.css_class">
                        <label v-html="`${val.name} ${val.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label "/>
                        <input 
                            :disabled="val.disabled"
                            :type="val.type" 
                            :class="val.class"
                            :id="for_update ? `refAlt${index}${j}${alt}` : `ref${index}${j}${alt}`"
                            v-model="form_data[val.model_name]"
                        />
                    </div>
                </span>

                <span v-else-if="key.type === 'switch'" :class="'custom-control custom-switch'">
                    <input
                        :type="'checkbox'"
                        :class="'custom-control-input'"
                        :id="for_update ? `refAlt${index}${alt}` : `ref${index}${alt}`"
                        :style="'height: 2rem; font-size:12px;'"
                        v-model="form_data[key.model_name]"
                        :ref="for_update ? key.ref_alt : key.ref"
                    />
                    <label
                        :class="'custom-control-label modal-label'"
                        :for="for_update ? `refAlt${index}${alt}` : `ref${index}${alt}`"
                    />
                </span>

                <div class="d-inline-block" v-else-if="key.type === 'radio'">
                    <div v-for="(val, i) in key.childs" :key="i" :class="'ml-3 custom-radio custom-control-inline'">
                        <input 
                            :class="'custom-control-input'" 
                            :type="key.type" 
                            :id="val.ref" 
                            v-model="form_data[key.model_name]" 
                            :value="val.value"
                        />
                        <label 
                            :for="val.ref" 
                            :class="'form-check-label custom-control-label'" 
                            v-html="val.name"
                        />
                    </div> 
                </div>

                <input v-else-if="key.type === 'tel'"
                    :disabled="key.disabled"
                    :type="key.type" 
                    :id="key.name" 
                    :name="key.name"
                    :required="key.required"
                    v-model="form_data[key.model_name]"
                />

                <div  v-else-if="key.type === 'vue-multiselect'" id="div__multiselect">
                    <multiselect    
                        :disabled="key.disabled"
                        v-model="form_data[key.model_name]"
                        :options="(array_options[key.model_name] && array_options[key.model_name].length) ? array_options[key.model_name].map(value => value.id) : []"
                        :custom-label="option => (array_options[key.model_name].find(value => value.id == option)) ? array_options[key.model_name].find(value => value.id == option).name : 'Item was deleted'"
                        placeholder="Select option"
                        :multiple="key.multiple"
                        :close-on-select="!key.multiple"
                        :clear-on-select="false"
                        :ref="for_update ? key.ref_alt : key.ref"
                        @select="$emit('selectOption', $event)"
                        @remove="$emit('removeOption', $event)"
                    >
                     <template v-if="key.show_number_items_selected" slot="tag">{{ '' }}</template>
                     <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="key.show_number_items_selected && values.length &amp;&amp; !isOpen" v-html="(values.length === array_options[key.model_name].length) ? `${values.length - 1} ${key.items_selected_message}` : `${values.length} ${key.items_selected_message}`"/>
                    </template>
                    </multiselect>
                </div>
                
                <div v-else-if="key.type === 'file'">
                <!-- <p class="mb-2 mt-1" v-if="form_data[key.model_name].storage_ubication">A file has been uploaded <a :href="form_data[key.model_name].storage_ubication" target="_blank">see file</a></p> -->
                <input 
                    type="file" 
                    :maxlength="key.maxlength"
                    :style="key.disabled ? 'background-color: #f1f1f1;' : ''"
                    :min="key.type === 'date' && min_date !== undefined ? min_date : key.minlength !== undefined ? key.minlength : ''"
                    :max="key.type === 'date' && max_date !== undefined ? max_date : key.maxlength"
                    :required="key.required"
                    :accept="array_options[key.model_name]"
                    @change="changeOnFile(key.model_name, $event)"
                    :ref="key.model_name"
                    :multiple="key.multiple"
                />
                    <ul class="list-group mt-3 mb-2">
                        <li class="list-group-item py-0" v-for="(image, index) in form_data[key.model_name]" :key="index">
                        <div class="row align-items-center">
                            <div class="col-md-9">
                                <img id="image-preview-imageKey" :src="image.file_data" alt="Image Preview" style="max-width: 130px; max-height: 130px;" />
                                <b class="ml-2">{{ image.name }}</b>
                            </div>
                            <div class="col-md-3">
                                <button type="button" class="modal__buttons__item cancel" style="width: 4rem;" @click="() => form_data[key.model_name].splice(index, 1)">Remove</button>
                            </div>
                        </div>
                        </li>
                    </ul>
                </div>
                <date-range-picker
                    v-else-if="key.type === 'date-picker'"
                    class="d-block"
                    ref="picker"
                    v-model="form_data[key.model_name]"
                    cancelLabel="Clear"
                    @finish-selection="captureSelectRange('')"
                >
                    <template v-slot:ranges="ranges">
                        <div class="ranges">
                            <ul>
                                <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range); captureSelectRange(name)">
                                    <b>{{ name }}</b> 
                                </li>
                                <li @click="captureSelectRange('This week'); ranges.clickRange(getThisWeekRange())">
                                    <b>This week</b> 
                                </li>
                                <li @click="captureSelectRange('Last week'); ranges.clickRange(getLastWeekRange())">
                                    <b>Last week</b> 
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-slot:input="picker" style="min-width: 350px;">
                        {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                    </template>

                    <div slot="footer" slot-scope="data" class="slot p-2">
                        <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                           {{ data.rangeText }}
                        </span>
                        <span style="margin-left: auto">
                            <a @click="clearRangeDate(data, key.model_name)" class="modal__buttons__item cancel">Cancel</a>
                        </span>
                        <span style="margin-left: auto">
                            <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                        </span>
                    </div>
                </date-range-picker>
                <div v-else-if="key.type === 'infinite-scroll-list'" id="infinite_scroll_list">
                    <div class="dropdown">
                        <button class="custom-dropdown w-80 px-3 ml-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="key.disabled">
                           {{ getButtonText(key) }}
                        </button>
                        <div @click="handleDropdownClick(key.close_on_option)">
                            <div class="dropdown-menu pt-0" aria-labelledby="dropdownMenuButton" style="max-height: 30vh; overflow-y: auto; width: 100%" ref="rooms_infinite_loader">
                                <div class="mt-2" style="background-color: white; position: sticky; top: 0; z-index: 1;" v-if="key.search">
                                    <div class="input-field my-3 m-3 sticky-top" style="width: 75%;  background-color: white;">
                                        <i class="material-icons prefix iconInput">search</i>
                                        <input type="text" placeholder="Search" id="input-search-dropdown" class="validate inputSearch" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'search'})" ref="input_search_dropdown">
                                    </div>
                                </div>
                                <div class="mt-2" v-if="key.enable_check_all">
                                    <div class="custom-control custom-checkbox w-100">
                                        <input type="checkbox" class="custom-control-input" :id="for_update ? `form-update-checkall${key.model_name}${alt}` : `form-data-checkall${key.model_name}${alt}`" :checked="isCheckedAll(key.model_name)" @change="checkAll(key.model_name)"/>
                                        <label style="font-size: 0.8rem" class="custom-control-label reports__show-hide__label ml-2" v-html="''" :for="for_update ? `form-update-checkall${key.model_name}${alt}` : `form-data-checkall${key.model_name}${alt}`" />
                                    </div>
                                </div>
                                <div v-for="(item, i) in array_options[key.model_name]" :key="i" class="mt-2">
                                    <div :class="key.parent_class ? key.parent_class : 'custom-control'">
                                        <input :type="key.input_type" :class="key.input_class" :id="for_update ? `form-update${key.model_name}${item.id}${alt}` : `form-data${key.model_name}${item.id}${alt}`" :value="item.id" v-model="form_data[key.model_name]" />
                                        <label style="font-size: 0.8rem" :class="key.label_input_class" v-html="item[key.track_by]" :for="for_update ? `form-update${key.model_name}${item.id}${alt}` : `form-data${key.model_name}${item.id}${alt}`" />
                                    </div>
                                </div>
                                <div style="display: flex; justify-content: center; align-items: center;" v-if="loading_records"> 
                                    <div class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <input v-else 
                    :placeholder="key['placeholder'] !== undefined ? key.placeholder : ''"
                    :disabled="key.disabled"
                    :step="key.step"
                    :type="key.type" 
                    :maxlength="key.maxlength"
                    :style="key.disabled ? 'background-color: #f1f1f1;' : ''"
                    :min="key.type === 'date' && min_date !== undefined ? min_date : key.minlength !== undefined ? key.minlength : ''"
                    :max="key.type === 'date' && max_date !== undefined ? max_date : key.maxlength"
                    :required="key.required"
                    v-model="form_data[key.model_name]"
                    :pattern="key.pattern ? key.pattern : '.*'"
                    :ref="for_update ? key.ref_alt : key.ref"
                />
            </div>
        </div>
        <slot :name="`more-fields`"></slot>  
    </div>
</template>

<script>
import moment from 'moment'
import Multiselect  from    "vue-multiselect"
import DateRangePicker from 'vue2-daterange-picker'
import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
// const Cryptr = require('cryptr');
// const Crypt = new Cryptr('myTotalySecretKey');

export default {

    name: 'FormDynamic',

    props:[
        'form_format',
        'form_data',
        'array_options',
        'for_update',
        'alt',
        'min_date',
        'max_date',
        'content_align_x',
        'loading_records',
        'name'
    ],

    components: {
        Multiselect,
        DateRangePicker
    },

    data() {
        return {
            notyf
        }
    },

    methods: {
        getButtonText(key) 
        {
            if(key.input_type == 'checkbox')
            {
                const model_name = key.model_name
                const modelData = this.form_data[model_name];

                if (modelData && modelData.length) 
                {
                    const length = modelData.length;
                    return `${length} ${length > 1 ? 'options' : 'option'} ${length > 1 ? 'are' : 'is'} selected`;
                } 
                else 
                {
                    return key.placeholder;
                }
            }
            else if(key.input_type == 'radio')
            {
                const model_name = key.model_name
                const modelData = this.form_data[model_name];

                if (modelData) 
                {
                    return this.array_options[key.model_name].find(item => item.id == modelData)[key.track_by]
                } 
                else 
                {
                    return key.placeholder;
                }
            }
        },
        changeOnFile(key, event)
        {
            const files = event.target.files
            let error_files = 0
            let error_files_size = 0;
            const max_file_size = 2 * 1024 * 1024;

            for(let i = 0; i < files.length; i++)
            {
                const the_file = files[i]
                if (this.array_options[key].includes(the_file.type))
                {
                    let image = {storage_ubication: 'assignments', key: '', size: '', type: ''}

                    image.name = the_file.name
                    image.size = the_file.size
                    image.type = the_file.type
                    
                    if (the_file.size > max_file_size) 
                    {
                        error_files_size++;
                    }
                    else
                    {
                        const reader = new FileReader(); 
                        reader.readAsDataURL(the_file);
                        reader.onload = (e) => {
                            image.file_data  = e.target.result
                            this.form_data[key].unshift(image)
                        }
                    }
                }
                else 
                {
                    error_files++
                }

                if(this.$refs.new_assignment_room_images)
                {
                    this.$refs.new_assignment_room_images.value = null
                }
                if(this.$refs.new_inspection_room_images)
                {
                    this.$refs.new_inspection_room_images.value = null
                }
            }

            if(error_files_size)
            {
                this.notyf.error(`${error_files_size} file(s) exceeds the 2MB size limit.`)
            }
            if(error_files)
            {
                setTimeout(() => {
                    this.notyf.error(`${error_files} file(s) are not compatible`)
                }, 100)
            }
            
            if(!error_files_size && !error_files)
            {
                this.notyf.success("All files are compatible")
            }
        },

        changePage(event)
        {
            this.$emit('changePage', event)
        },

        clearInputSearch()
        {
            const inputElement = this.$refs.input_search_dropdown;

            inputElement.value = '';
        },
        
        handleDropdownClick(close) {
            if(!close)
            {
                event.stopPropagation()
            }
        },

        isCheckedAll(model_name)
        {
            let check = false

            if(this.form_data[model_name].length)
            {

                check = this.array_options[model_name] && this.array_options[model_name].length === this.form_data[model_name].length
            }
            return check
        },

        checkAll(model_name)
        {
            if(!this.isCheckedAll(model_name))
            {
                this.array_options[model_name].forEach(option => 
                {
                    let found_index = this.form_data[model_name].findIndex(item => item === option.id)

                    if(found_index < 0)
                    {
                        this.form_data[model_name].push(option.id)
                    }
                })
            }
            else
            {
                this.form_data[model_name] = []
            }   
        },
        clearRangeDate(data, model_name)
        {
            data.clickCancel()
            this.form_data[model_name] = { startDate: null, endDate: null }
        },
        date(val) 
        {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        captureSelectRange(range)
        {
            this.$emit('getSelectDateRange', range)
        }
    },
    mounted()
    {
        let tableScrollBody = this.$refs["rooms_infinite_loader"];
        if(tableScrollBody)
        {
            tableScrollBody = tableScrollBody[0]
            tableScrollBody.addEventListener("scroll", this.changePage);
        }
    },

    beforeDestroy() {
        let tableScrollBody = this.$refs["rooms_infinite_loader"];
        if(tableScrollBody)
        {
            tableScrollBody = tableScrollBody[0]
            tableScrollBody.removeEventListener("scroll", this.changePage);
        }
    }

}
</script>